<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :deaprtFlag="false" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
        <div name="tabs-block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="auditAll"></el-tab-pane>
                <el-tab-pane name="auditInitial">
                    <span slot="label">未审核<i class="num-marker">{{appliedCount}}</i></span>
                </el-tab-pane>
                <el-tab-pane label="审核已通过" name="auditPass"></el-tab-pane>
                <el-tab-pane name="auditFail">
                    <span slot="label">审核未通过<i class="num-marker">{{auditFailCount}}</i></span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="mt5">
            <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        </div>
    </div>
</template>
<script>
import { $, Utils } from '../../app.base'
import { DomSizeWatcher, MsgBox, Vue } from '../../app.vues'
import { checkUserActionPerm } from '../index'
import { getDefaultPageSizes } from '../../app.conf'
import { openAssetVoucherAuditDlg } from '../scrapVoucher/selectDlg'
import { getMerchtAuditBpConfInfo } from '../oaAudit/selectDlg'

import SwbShopDeviceClearVoucherShow from './ShopDeviceClearVoucherShow'
import SwbResultColConf from '../query/ResultColConf.vue';
import SwbResultTable from '../query/ResultTable.vue';
//
import assetVchrApi from '../../api/assetVchr'
import userApi from '../../api/user'

Vue.regist(SwbShopDeviceClearVoucherShow);

Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

export default {
        name: 'swb-clear-device-io-voucher-list',
        desc: '清除资产列表',
        path: '/shop/device/clear/voucher/audit/list',
        avlActions: 'view_detail|audit|view_rec',
        avlActionNames: '查看详情',
        avlScopes: 'retailer',
        data: function () {
            return {
                confKey: "swb-clear-device-io-voucher-audit-list",
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                voucherTypeMap: [],
                //排序、搜索
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                activeName: "auditAll",
                appliedCount: 0,
                auditFailCount: 0,
                //
                comLevel: null,
                bizUnitId: null,
                selectComId: null,
                includeSubComs: null,
                //
                dingDingAuditFlag: false,
                no: null
            }
        },
        created: function () {
            this.voucherTypeMap = getEnumMap("devcVoucherType", "value2text");
            let self = this;
            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.queryModel.filterItems.no = no;
                this.no = no;
            }
            //
            getMerchtAuditBpConfInfo("retailer.assets.clear", false, function (auditBpConfInfo) {
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2 && auditBpConfInfo.ready);
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout,[name="query-sort-area"],[name="tabs-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let no = this.no;
                if(!Utils.isNoB(no)) {
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            // 获取用户当前信息
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.merchantId = data.scopeEntity.id;
                        self.comLevel = data.scopeEntity.comLevel;
                        self.selectComId = data.scopeEntity.comId;
                        self.bizUnitId = data.scopeEntity.bizUnitId;
                        self.bizUnitName = data.scopeEntity.bizUnitName;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.srcVoucherType != null) {
                            return '<span class="swb-tags swb-tags-danger">' + self.voucherTypeMap[row.srcVoucherType] + '</span>' + '<span >' + colValue + '</span>';
                        } else {
                            return '<span >' + colValue + '</span>';
                        }
                    },
                    'unbind': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span >是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'createOutVoucher': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.createOutVoucher) {
                            return '<span class="font-green">已生成</span>';
                        } else {
                            return '<span class="font-red">未生成</span>';
                        }
                    },
                    'auditState': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.applyState == 1) {
                            return '<span>未审核</span>';
                        } else if(row.applyState == 2) {
                            if(colValue === 1) {
                                return '<span class="font-green">审核已通过</span>';
                            } else if(colValue === -1) {
                                return '<span class="font-red">审核未通过</span>';
                            }
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('view_detail', null, row.comId)) {
                            domHtml = domHtml + '<a name="view_detail" class="swb-btn swb-btn-link">查看详情</a>';
                        }
                        if(self.checkActionPerm('audit', row.auditorPostId, row.comId) && !row.outerAuditFlag && row.applyState == 1 && row.auditState != 1) {
                            domHtml = domHtml + '<a name="audit" class="swb-btn swb-btn-link">审核</a>';
                        }
                        if(self.checkActionPerm('view_rec', null, row.comId)) {
                            domHtml = domHtml + '<a name="view_rec" class="swb-btn swb-btn-link">操作记录</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        if(btnName == 'view_detail') {
                            self.viewCearVoucher(row.id);
                        } else if(btnName == 'view_rec') {
                            self.showActRec(row.no);
                        } else if(btnName == 'audit') {
                            self.auditClearVoucher(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            // 操作权限控制
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.pageNumber = 1;
                this.getClearVoucherList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getClearVoucherList();
            },

            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getClearVoucherList();
            },
            handleClick(){
                this.handlePageChange(1);
            },
            getClearVoucherList: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.tabCheckFlag = self.activeName;
                let state = filterItems.state;
                filterItems.auditState = state;
                //
                filterItems.comLevel = self.comLevel;
                filterItems.bizUnitId = self.bizUnitId;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.retailerComId = self.selectComId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceClearVoucherList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows, pagination);
                        self.getApplyStateAppliedTodoCount();
                        self.getAuditStateAuditFailTodoCount();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkComCatChange: function (eventData) {
                this.comLevel = eventData.level;
                this.selectComId = eventData.id;
                this.bizUnitId = eventData.bizUnitId;
                this.bizUnitName = eventData.bizUnitName;
                this.includeSubComs = eventData.includeSubComs;
                this.getClearVoucherList();
            },
            getApplyStateAppliedTodoCount: function () {
                let self = this;
                let postData = {
                    assetType: -1,
                    comId: self.selectComId,
                    comLevel: self.comLevel,
                    includeSubComs: self.includeSubComs,
                    bizUnitId: self.bizUnitId
                };
                assetVchrApi.getShopDeviceClearVoucherApplyStateAppliedTodoCount(postData, function (result) {
                    if(result.type == "info") {
                        self.appliedCount = result.data;
                    }
                })
            },
            getAuditStateAuditFailTodoCount: function () {
                let self = this;
                let postData = {
                    assetType: -1,
                    comId: self.selectComId,
                    comLevel: self.comLevel,
                    includeSubComs: self.includeSubComs,
                    bizUnitId: self.bizUnitId
                };
                assetVchrApi.getShopDeviceClearVoucherAuditStateAuditFailTodoCount(postData, function (result) {
                    if(result.type == "info") {
                        self.auditFailCount = result.data;
                    }
                })
            },
            viewCearVoucher: function (id) {
                Vue.$showDialog({
                    title: "资产清除--详情",
                    width: 1500,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-clear-voucher :id="id"></swb-shop-device-clear-voucher>' +
                    '</div>',
                    data: {
                        id: id,
                    }
                });
            },
            // 审核清除单
            auditClearVoucher: function (row) {
                let self = this;
                let title = "资产清除单 -- 审核";
                openAssetVoucherAuditDlg(function (result) {
                    let auditState = result.auditState;
                    let postData = {
                        id: row.id,
                        auditState: auditState,
                        auditDesc: result.desc,
                    };
                    let theLoad = MsgBox.loading();
                    assetVchrApi.aduitShopDeviceClearVoucher(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            MsgBox.success('操作成功！');
                            if(auditState == 1) {
                                self.activeName = "auditPass";
                            } else if(auditState == -1) {
                                self.activeName = "auditFail";
                            }
                            self.getClearVoucherList();

                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, title);
            },
            // 清除单操作记录
            showActRec(no){
                Vue.$showDialog({
                    title: "清除单操作记录 - 查看",
                    width: 1200,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-shop-device-act-rec-list :showComFlag="false" :srcVoucherNo="srcVoucherNo" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                    '</div>',
                    data: {
                        srcVoucherNo: no,
                        srcVoucherType: getEnumInfoWith("devcVoucherType", "name", "Clear").value
                    }
                });
            },
            doUnBuild(id){
                let self = this;
                self.$confirm('确定要解绑此单据信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    assetVchrApi.updateShopDeviceClearVoucherUnBnbind(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.getClearVoucherList();
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/clearVoucher/ShopDeviceClearVoucherAuditList.vue